import { Email } from '../Common/Email';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext, useState, useEffect } from 'react';
import { InputTaxComponent } from '../InputTaxComponent/InputTaxComponent';
import { PayButton } from '../PaymentInputs/PayButton';
import { useVenmoBraintree } from '@/hooks/useVenmoBraintree';
import { isCountryCodeIsUSAOrCanada } from '@/utils/tax';
import { shouldHideEmail } from '@/utils/conditionalRendering';
import { isEmailValid } from '@/utils/email';

export const VenmoPayForm = () => {
  const {
    customer,
    actions: { setIsFormValid },
    totalPrice,
    paymentKeys,
    featureFlags,
  } = useContext(CheckoutContext);
  const [isAddressValid, setIsAddressValid] = useState(
    isCountryCodeIsUSAOrCanada(customer?.geoLocator?.countryCode2 ?? customer.taxCountry ?? '') ? false : true
  );
  const { handleSubmit } = useVenmoBraintree({ braintreePK: paymentKeys.braintree ?? '' });

  // Update global form validity
  useEffect(() => {
    const isFormValid = isEmailValid(customer?.email) && isAddressValid;
    setIsFormValid(isFormValid);
  }, [customer?.email, isAddressValid, setIsFormValid]);

  const handleValidate = (isValid: boolean) => {
    setIsAddressValid(isValid);
  };

  const handlePayment = async () => {
    await handleSubmit();
  };

  return (
    <div className="flex flex-col gap-4">
      {!shouldHideEmail(featureFlags) && <Email />}
      <InputTaxComponent onValidate={handleValidate} />
      <PayButton
        isDisabled={!isEmailValid(customer?.email) || !isAddressValid}
        onClick={handlePayment}
        price={totalPrice}
      />
    </div>
  );
};
